// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"494":"b26f2eac6bf8cb9c","715":"26fbe6fff4ec01c2"}[chunkId] + ".js";
};